export const Pages = {
	'Frequent questions': 'Preguntas frecuentes',
};
